import fetch from 'isomorphic-fetch';
import cookie from 'js-cookie';

/**
 * @param {Object} response 对象
 */
function parseRequest(response) {
  return new Promise((resolve, reject) => {
    if (response.text) {
      // 对于返回内容，首先都尝试转换为 json， 否则转换为纯文本
      response
        .text()
        .then(res => {
          let parseRes;
          try {
            parseRes = JSON.parse(res);
          } catch (error) {
            parseRes = res;
          }
          resolve(parseRes);
        })
        .catch(reject);
    } else {
      reject(response);
    }
  });
}

/**
 * @desc 检查 http 状态
 * @param {Object} response 对象
 */
function checkStatus(response, forceRedirect) {
  const { status, statusText } = response;

  if (status >= 200 && status < 300) {
    return response;
  }

  return response.text().then(
    text =>
      new Promise((resolve, reject) => {
        let resp;

        if (status === 401 && forceRedirect) {
          window.location.href = '/login';
        }

        try {
          resp = JSON.parse(text);
        } catch (error) {
          return reject(new Error({ status, statusText, message: text }));
        }

        return reject(resp);
      }),
  );
}

/**
 * 前后端公用的 fetch 方法
 * @param {string} 请求 url
 * @param {Object} 请求 options，包含 header、payload 等
 */
export default (url, opts = {}) => {
  const options = Object.assign(
    {
      method: 'GET',
      // credentials: 'include',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `jwt ${cookie.get('AUTH')}`,
      },
      forceRedirect: true,
    },
    opts,
  );

  if (
    (options.method.toLowerCase() === 'get' &&
      url.indexOf('/system/settings/') !== -1) ||
    !cookie.get('AUTH')
  ) {
    delete options.headers.Authorization;
  }

  const contentType =
    options.headers['Content-Type'] || options.headers['content-type'];

  if (contentType.toLowerCase().indexOf('application/json') >= 0) {
    options.body = JSON.stringify(opts.body);
  }

  return fetch(url, options)
    .then(res => checkStatus(res, opts.forceRedirect))
    .then(parseRequest)
    .then(result => ({ result, options }))
    .catch(error => ({ error, options }));
};
